


export default class PrintOutput {
    x = "";
    y= "";
    z = 0;
    zonly = false;
    multi = "x";
    eq = "=";
    einheit = ""
    constructor(x="",y="",z=0,einheit="",zonly=false,multi="x",eq="="){
        this.x = x;
        this.y = y;
        this.z = z;
        this.zonly = zonly;
        this.multi = multi;
        this.eq = eq;
        this.einheit = einheit
    }

    getCombinedVal() {
        if (this.zonly) {
            return this.z;
        }
        return this.x + " " +this.multi + " " + this.y + " " + this.eq + " " + this.z + this.einheit
    }
    getCombinedArrayVal(){
        if (this.zonly) {
            return [{text:this.z,bold:false,alignment:"right"},"",""];
        }
        let outtable = {table: {
                widths: [65,20],
                body: [[{text:this.z,bold:true,alignment:"right"},{text:this.einheit,bold:true,alignment:"left"}]]
            },layout: 'noBorders'};
        return [{text:this.x + " " +this.multi + " " + this.y,bold:false,alignment:"right"},{text:this.eq+"",bold:false,alignment:"right"},outtable];//{text:this.z+this.einheit,bold:true,alignment:"right"}]
    }

}


// WEBPACK FOOTER //
// ./src/models/PrintOutput.js